<template>
  <div>
    <h1>{{titulo}}</h1>
  </div>
</template>

<script>
export default {
  name: "Privacidade",
  data() {
    return {
      titulo: "Política de Privacidade"
    };
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Privacidade.vue